import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { COLORS } from '../constants';
import { MaterialIcons } from '@expo/vector-icons';
import { CommonActions } from '@react-navigation/native';


import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';

export default function ResetBtn(props) {

  const navigation = useNavigation();

  const handleReset = () => {
    AsyncStorage.clear();

    navigation.dispatch(
      CommonActions.reset({
        index: 1,
        routes: [
          {name: 'Welcome' },
          {name: 'Profile' },
        ],
      })
    );
  };


  return (
    <>
      <TouchableOpacity
        style={styles.headerRight}
        onPress={() => { handleReset() }}
      >
        <View style={styles.resetBtn}>
          <MaterialIcons name="cached" size={24} color={COLORS.accent} />
        </View>
      </TouchableOpacity>
    </>
  )
}

const styles = StyleSheet.create({
  headerRight: {
    padding: 15,
  },
  resetBtn: {
    width: 50,
    height: 50,
    justifyContent: 'center',
    alignItems: 'center',
  }
})